import { Outlet } from "react-router-dom";
import { AppShell } from "./AppShell";

export default function Root() { return <AppShell><Outlet /></AppShell>; }
